if (document.getElementById("root")) {
	void import("./app.js").then(({ mount }) => {
		mount();
	});
}
